import { render, staticRenderFns } from "./dialog-approve-xuyingxiaozhuren.vue?vue&type=template&id=4ecb216a&scoped=true&"
import script from "./dialog-approve-xuyingxiaozhuren.vue?vue&type=script&lang=js&"
export * from "./dialog-approve-xuyingxiaozhuren.vue?vue&type=script&lang=js&"
import style0 from "./dialog-approve-xuyingxiaozhuren.vue?vue&type=style&index=0&id=4ecb216a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecb216a",
  null
  
)

export default component.exports